// extracted by mini-css-extract-plugin
module.exports = {"PhotoSidebar":"styles-module--PhotoSidebar--3tBLF","active":"styles-module--active--fOe38"};